import React from "react";
import video from "../assets/images_assoc/vid1.mp4";

const VideoSection = () => {
    return (
        <div className="w-full bg-black pb-10 pt-16 lg:py-20 px-4">
            <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">

                {/* Texte (gauche) */}
                <div className="w-full lg:w-1/2 flex flex-col items-start gap-4 lg:gap-6">
                    <span className="inline-block bg-violet-600 text-white text-xs sm:text-sm font-semibold tracking-widest uppercase px-3 py-1 rounded-full">
                        Vivez l'instant
                    </span>

                    <h2 className="font-archivo font-extrabold text-white tracking-wide
                        text-3xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-6xl leading-tight">
                        Des événements qui rassemblent
                    </h2>

                    <p className="font-archivo text-white/90 text-base sm:text-lg lg:text-xl leading-relaxed">
                        Concerts, festivals, soirées et rencontres — retrouvez l'énergie des meilleurs
                        moments près de chez vous.
                    </p>
                </div>

                {/* Vidéo (droite) */}
                <div className="w-full lg:w-1/2">
                    <video
                        src={video}
                        autoPlay
                        muted
                        loop
                        playsInline
                        className="w-full h-[50vh] lg:h-[70vh] object-cover rounded-2xl"
                    />
                </div>

            </div>
        </div>
    );
};

export default VideoSection;